module.exports = __webpack_public_path__ + "img/logoPLMslogan.ed58cba4.svg";